import axios from "axios";
import { API_AUTHENTICATE, API_CONTACT_MESSAGES, API_DEMO_REQUESTS, API_OTP_VERIFICATION, API_PASSWORD_REQUEST } from "./config";
import { logoutLocal } from "./services/logoutUser";

const httpClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

const PUBLIC_API_PATHS = [
  API_AUTHENTICATE,
  API_OTP_VERIFICATION,
  API_PASSWORD_REQUEST,
  API_CONTACT_MESSAGES,
  API_DEMO_REQUESTS,
];

function isPublicApi(url = "") {
  return PUBLIC_API_PATHS.some((path) => url.includes(path.replace(/^\//, "")) || url.includes(path));
}

const onSuccess = (res) => Promise.resolve(res.data);
const onError = ({ response, config }) => {
  if (response === undefined) {
    let serviceNotReachable = { data: [{ require: "serviceNotReachable" }] };
    return Promise.reject(serviceNotReachable);
  } else {
    if (response.status === 401 && !response.data?.data && !isPublicApi(config?.url)) {
      logoutLocal()
    }
    return Promise.reject(response);
  }
};


httpClient.interceptors.request.use((request) => {
  if (!isPublicApi(request.url)) {
    request.headers.Authorization = `Bearer ${localStorage.getItem("authToken")}`;
  }
  return request;
});

httpClient.interceptors.response.use((response) => response);

httpClient.interceptors.response.use(onSuccess, onError);

export default httpClient;
